import { api } from '@/main'
import { DirectUpload } from 'activestorage'
import Vue from 'vue'

const defaultState = {
  currentRecordTenantsDocuments: {},
  currentRecordGuarantorsDocuments: {}
}

export default {
  namespaced: true,
  state: {
    ...defaultState
  },
  mutations: {
    RESET_MODULE: state => {
      Object.keys(state).forEach(key => {
        state[key] = defaultState[key]
      })
    },
    SET_CURRENT_RECORD_DOCUMENTS_DATA: (state, data) => {
      state.currentRecordTenantsDocuments = { ...data.tenantsDocuments }
      state.currentRecordGuarantorsDocuments = { ...data.guarantorsDocuments }
    },
    SET_SPECIFIED_ID_CURRENT_DOCUMENTS: (state, data) => {
      Vue.set(
        state[
          `currentRecord${
            data.type === 'guarantor' || data.type === 'Guarantor'
              ? 'Guarantors'
              : 'Tenants'
          }Documents`
        ],
        data.id,
        data.documents
      )
    }
  },
  actions: {
    resetModule(store) {
      store.commit('RESET_MODULE')
    },
    async getCurrentRecordPeopleDocuments(store) {
      const record = store.rootState.records.currentRecord
      let tenantsDocuments = {}
      let guarantorsDocuments = {}

      if (record) {
        if (record.tenant_ids && record.tenant_ids.length > 0) {
          for await (let id of record.tenant_ids) {
            tenantsDocuments[id] = await api.recordsPeople.getTenantDocuments({
              id
            })
          }
        }

        if (record.guarantor_ids && record.guarantor_ids.length > 0) {
          for await (let id of record.guarantor_ids) {
            guarantorsDocuments[
              id
            ] = await api.recordsPeople.getGuarantorDocuments({ id })
          }
        }

        store.commit('SET_CURRENT_RECORD_DOCUMENTS_DATA', {
          tenantsDocuments,
          guarantorsDocuments
        })
      }
    },
    async getRecordPeopleDocuments(store, { id, type }) {
      if (type === 'Guarantor' || type === 'guarantor') {
        const guarantorDocuments = await api.recordsPeople.getGuarantorDocuments(
          { id }
        )
        store.commit('SET_SPECIFIED_ID_CURRENT_DOCUMENTS', {
          type,
          id,
          documents: guarantorDocuments
        })
      } else if (type === 'Tenant' || type === 'tenant') {
        const tenantDocuments = await api.recordsPeople.getTenantDocuments({
          id
        })
        store.commit('SET_SPECIFIED_ID_CURRENT_DOCUMENTS', {
          type,
          id,
          documents: tenantDocuments
        })
      }
    },
    async uploadFile(store, params) {
      return new Promise((resolve, reject) => {
        const upload = new DirectUpload(params.file, api.getFileUploadUrl(), {
          directUploadWillCreateBlobWithXHR: xhr => {
            // This will decorate the requests with the access token header so you won't get a 401
            xhr.setRequestHeader(
              'Authorization',
              `Bearer ${localStorage.getItem(
                localStorage.getItem('authToken') ? 'authToken' : 'offlineToken'
              )}`
            )
          }
        })

        upload.create(async (error, blob) => {
          if (error) {
            reject(error)
          } else {
            if (params.type === 'Guarantor' || params.type === 'guarantor') {
              await api.recordsPeople.createGuarantorDocument({
                target_id: params.target_id,
                document_type_id: params.document_type_id,
                document: {
                  file: blob.signed_id
                }
              })
            } else if (params.type === 'Tenant' || params.type === 'tenant') {
              await api.recordsPeople.createTenantDocument({
                target_id: params.target_id,
                document_type_id: params.document_type_id,
                document: {
                  file: blob.signed_id
                }
              })
            }

            await store.dispatch('getRecordPeopleDocuments', {
              id: params.target_id,
              type: params.type
            })

            resolve()
          }
        })
      })
    },
    async deleteFile(store, params) {
      if (params.type === 'Guarantor' || params.type === 'guarantor') {
        await api.recordsPeople.deleteGuarantorDocument({
          target_id: params.target_id,
          document_type_id: params.document_type_id
        })
      } else if (params.type === 'Tenant' || params.type === 'tenant') {
        await api.recordsPeople.deleteTenantDocument({
          target_id: params.target_id,
          document_type_id: params.document_type_id
        })
      }

      await store.dispatch('getCurrentRecordPeopleDocuments')
    }
  }
}
